export const formatLargeNumber = (num: number) => {
  if (num >= 1e6) return (num / 1e6).toFixed(1).replace(/\.0$/, '') + 'M';
  if (num >= 1e3) return (num / 1e3).toFixed(1).replace(/\.0$/, '') + 'k';
  return num;
};

export const formatPercentage = (num: number, decimals: number = 0): string => {
  return (num * 100).toFixed(decimals).replace(/\.0+$/, '') + '%';
};
